import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISpeakerProfile } from 'rev-portal/scheduledEvents/webcast/WebcastBranding';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';


@Component({
	selector: 'webcast-speakers',
	templateUrl: './WebcastSpeakers.Component.html',
	styleUrl: './WebcastSpeakers.ng.less',
	imports: [
		CommonModule,
		VbProfilePictureModule
	]
})
export class WebcastSpeakersComponent {
	@Input() public speakers: ISpeakerProfile;
}
